import { Outlet } from "@tanstack/react-router";
import { Logo } from "@/components/layout/Logo";
import { LanguageToggle } from "@/components/layout/LanguageToggle";
import { ThemeToggle } from "@/components/layout/ThemeToggle";
import { useI18n } from "@/i18n";

/** Moldura das telas públicas (login, cadastro, reset…). */
export function AuthLayout() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-full flex-col bg-gradient-to-b from-primary/5 to-background">
      <header className="flex items-center justify-between p-4 sm:p-6">
        <Logo />
        <div className="flex items-center gap-1">
          <LanguageToggle />
          <ThemeToggle />
        </div>
      </header>
      <main id="main" className="flex flex-1 items-start justify-center px-4 pb-16 pt-4 sm:items-center">
        <div className="w-full max-w-sm">
          <Outlet />
        </div>
      </main>
      <footer className="pb-6 text-center text-xs text-muted-foreground">{t("auth.tagline")}</footer>
    </div>
  );
}
